import { useEffect } from 'react';
import './DetailWindow.css';

import { Fade } from 'react-reveal';

function DetailsWindow({details, image, textWidth = "50vh", imgWidth = "50vh"}){
    return(
        <div className="DetailWin">

            <Fade bottom distance="40%" duration={750}>
                <div className='DetailTekst' style={{width: textWidth}}>
                    <pre>{details}</pre>
                </div>
            </Fade>
            {image && 
                <Fade bottom distance="40%" duration={750}>
                    <div className='DetailImg' style={{width: imgWidth}}>
                        <img src={image}></img>
                    </div>
                </Fade>
            }
        </div>
    );
}

export default DetailsWindow;